module.exports = __webpack_public_path__ + "static/media/fourBg.981900ec.jpg";